import React, { FunctionComponent, SetStateAction, Dispatch } from 'react';
import Translation from '../../../../../../gqlCommon/components/translation/Translation';
import ModalWithHeader from '../../../../../../common/components/presentation/ModalWithHeader';
import SpecificationsListContainer from './SpecificationsListContainer';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';
import { useTheme } from '@material-ui/core';

interface ISpecificationsModalProps {
  isOpen: boolean;
  toggleModal: Dispatch<SetStateAction<boolean>>;
}

const SpecificationsModal: FunctionComponent<ISpecificationsModalProps> = ({ isOpen, toggleModal }) => {
  const {
    spc: {
      customise: { isSpecificationByGroup },
    },
  } = useTheme<ISpcTheme>();

  return (
    <ModalWithHeader
      open={isOpen}
      toggleModal={toggleModal}
      title={
        <Translation
          id={
            isSpecificationByGroup
              ? 'trans__configurator__customise_page_variant_section__specs_modal_title'
              : 'trans__configurator__customise_page_variant_section__specification_subtitle'
          }
        />
      }
    >
      <SpecificationsListContainer isOpen={isOpen} />
    </ModalWithHeader>
  );
};

export default SpecificationsModal;
